import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

const footerColumns = [
  {
    titleKey: 'footer.sections.happening',
    links: [
      { key: 'footer.links.happeningAll',         href: '/happening'              },
      { key: 'footer.links.happeningEvents',       href: '/happening/events'       },
      { key: 'footer.links.happeningExperiences',  href: '/happening/experiences'  },
    ],
  },
  {
    titleKey: 'footer.sections.work',
    links: [
      { key: 'footer.links.workLiving',     href: '/work/living'     },
      { key: 'footer.links.workHealthcare', href: '/work/healthcare' },
      { key: 'footer.links.workTravel',     href: '/work/travel'     },
    ],
  },
  {
    titleKey: 'footer.sections.study',
    links: [
      { key: 'footer.links.studyEducation', href: '/study/education' },
      { key: 'footer.links.studyColleges',  href: '/study/colleges'  },
    ],
  },
  {
    titleKey: 'footer.sections.invest',
    links: [
      { key: 'footer.links.investAbout',   href: '/invest/about'    },
      { key: 'footer.links.investSectors', href: '/invest/sectors'  },
      { key: 'footer.links.investSetup',   href: '/invest/business' },
    ],
  },
  {
    titleKey: 'footer.sections.shop',
    links: [
      { key: 'footer.links.shopNew',     href: '/shop/new'            },
      { key: 'footer.links.shopBest',    href: '/shop/best'           },
      { key: 'footer.links.shopCollabs', href: '/shop/collaborations' },
    ],
  },
  {
    titleKey: 'footer.sections.partners',
    links: [
      { key: 'footer.links.partnersMedia',    href: '/partners/media-kit' },
      { key: 'footer.links.partnersPress',    href: '/partners/press'     },
      { key: 'footer.links.partnersContact',  href: '/partners/contact'   },
      { key: 'footer.links.partnersSecurity', href: '/partners/security'  },
    ],
  },
];

const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="footer">
      {/* Newsletter */}
      <div className="footer__newsletter">
        <div className="footer__container">
          <h2 className="footer__newsletter-title">{t('footer.newsletter.title')}</h2>
          <form className="footer__newsletter-form" onSubmit={handleSubscribe}>
            <div className="footer__input-wrap">
              <svg className="footer__search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="7" stroke="#aaa" strokeWidth="2" />
                <path d="M16.5 16.5L21 21" stroke="#aaa" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <input
                type="email"
                className="footer__input"
                placeholder={t('footer.newsletter.placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="footer__subscribe-btn">{t('footer.newsletter.button')}</button>
          </form>
        </div>
      </div>

      {/* Links grid */}
      <div className="footer__links">
        <div className="footer__container">
          <div className="footer__grid">
            {footerColumns.map((col) => (
              <div key={col.titleKey} className="footer__col">
                <h4 className="footer__col-title">{t(col.titleKey)}</h4>
                <ul className="footer__col-list">
                  {col.links.map((link) => (
                    <li key={link.href}>
                      <a href={link.href} className="footer__col-link">{t(link.key)}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="footer__container footer__bottom-inner">
          <p className="footer__copy">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className="footer__socials">
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label={t('footer.social.youtube')}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1C4.5 20.4 12 20.4 12 20.4s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z"/>
              </svg>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label={t('footer.social.facebook')}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/yoursharjah" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label={t('footer.social.instagram')}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
